import { ANSWERS_ROUTE } from './constants';
import { TEXT_ANSWERS_ROUTE,BIND_TYPE_TEXT_ANSWERS_ROUTE } from './text/constants';
import { CHECKBOX_ANSWERS_ROUTE } from './checkbox/constants';
import { IMAGE_ANSWERS_ROUTE } from './image/constants';
import { SCALE_ANSWERS_ROUTE } from './scale/constants';
import { FREE_TEXT_ANSWERS_ROUTE } from './freeText/constants';
import { TEXT_POLL_ANSWERS_ROUTE } from './textPoll/constants';
import { SORT_ORDER_ANSWERS_ROUTE } from './sortOrder/constants';
import { AD_ANSWERS_ROUTE } from './ad/constants';

import http from '../../../utils/httpService';

/**
 *
 * @param type
 * @returns {string}
 */
const getRouteByQuestionType = type => {
    switch(type) {
        case 'text': 
            return TEXT_ANSWERS_ROUTE;
        case 'checkbox':
            return CHECKBOX_ANSWERS_ROUTE;
        case 'image':
            return IMAGE_ANSWERS_ROUTE;
        case 'scale':
            return SCALE_ANSWERS_ROUTE;
        case 'free_text':
            return FREE_TEXT_ANSWERS_ROUTE;
        case 'text_poll':
            return TEXT_POLL_ANSWERS_ROUTE;
        case 'text_in_order':
            return SORT_ORDER_ANSWERS_ROUTE;
        case 'ad': 
            return AD_ANSWERS_ROUTE;

        default: 
            return ANSWERS_ROUTE;
    }
};
/**
 *
 * @param questionID
 * @param answer
 * @param localizationId
 * @param questionType
 * @param resolve
 */
const requestAnswerCreation = (questionID, answer, localizationId, questionType, resolve) => {
    const answerBody = {
        question_localization_id: localizationId,
        ...answer
    };

    const route = getRouteByQuestionType(questionType);
    const formData = new FormData();
    Object.keys(answerBody).forEach(key => formData.append(key, answerBody[key]));

    return http.request(route, 'POST', formData, true, resolve);
};

/**
 *
 * @param questionID
 * @param answerId
 * @param answer
 * @param questionType
 * @param resolve
 */
const requestAnswerUpdating = (questionID, answerId, answer, questionType, resolve) => {
    const answerBody = {
        question_localization_id: questionID,
        ...answer
    };
    const route = getRouteByQuestionType(questionType);
    return http.request(route + `/${answerId}`, 'PUT', answerBody, false, resolve)
};

/**
 *
 * @param answerId
 * @param questionType
 */
const requestAnswerDeleting = (answerId, questionType) => {
    const route = getRouteByQuestionType(questionType);
    return http.request(route + `/${answerId}`, 'DELETE');
};

/**
 *
 * @param bindObjectId
 * @param typeId
 * @param answerId
 * @param answerType
 * @param points
 */
const requestBindTypeToAnswer = ({bindObjectId,typeId,answerId,answerType,points}) =>{
    const body = {
        id: bindObjectId,
        person_type_id:typeId,
        answer_id: answerId,
        answer_type: answerType,
        points,
    };

    return http.request(BIND_TYPE_TEXT_ANSWERS_ROUTE + bindObjectId, 'PUT', body);
};

export {
    requestAnswerCreation,
    requestAnswerUpdating,
    requestAnswerDeleting,
    requestBindTypeToAnswer
};